import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberUtils from '../../utils/NumberUtils';
import { SavingPotsList } from './SavingPotsList';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import BrowserUtils from '../../utils/BrowserUtils';
import SiteHeaderActionHeader from '../../actions/SiteHeaderActionCreator';

let potContent;

/**
 * @todo
 * the quality of this component is poor.
 * Future improvement work should be undertaken to align to best practice.
 */
class SavingPots extends Component {
  constructor(props) {
    super(props);

    this.getCreateSavingPot = this.getCreateSavingPot.bind(this);
  }

  componentWillMount() {
    BrowserUtils.isMobileView() && SiteHeaderActionHeader.hideHeaderFlag(true);
  }
  componentWillUnmount() {
    SiteHeaderActionHeader.hideHeaderFlag(false);
  }

  getCreateSavingPot() {
    SavingPotsActionCreator.getCreateSavingPotPage();
  }

  render() {
    let content = this.props.content;
    const pots = this.props.pots;
    const unallocatedAmount = NumberUtils.appendCurrency(
      '{}',
      this.props.unallocatedAmount
    );
    let potHeaderContent;
    if (pots.length > 0) {
      potContent = pots.map((pot, i) => (
        <SavingPotsList
          key={`potContent_SavingPotsList_${i}`}
          pot={pot}
          content={content}
        />
      ));
      if (BrowserUtils.isMobileView()) {
        potHeaderContent = (
          <div className="unallocated__message">
            {content.savingpotMainPageTitle1}{' '}
            <strong>{unallocatedAmount}</strong>{' '}
            {content.savingpotMainPageTitle2}
          </div>
        );
      } else {
        potHeaderContent = (
          <div>
            <div className="unallocated__message">
              {content.savingpotMainPageTitle1}{' '}
              <strong>{unallocatedAmount}</strong>{' '}
              {content.savingpotMainPageTitle2}
            </div>
            <div className="create_savingspot">
              <button
                type="button"
                className="page-options opt-green btn btn-link"
                onClick={this.getCreateSavingPot}
              >
                <span className="icon icon-add" />
                {content.SavingLinkPot}
              </button>
            </div>
          </div>
        );
      }
    } else {
      if (BrowserUtils.isMobileView()) {
        potContent = (
          <button
            onClick={this.getCreateSavingPot}
            type="button"
            className="col-xs-12 noPotMessage"
          >
            {content.SavingLinkSetupPotMobile}
          </button>
        );
        potHeaderContent = (
          <div className="create_savingspot">
            {content.savingpotNoPotMobile}
          </div>
        );
      } else {
        potContent = (
          <button
            onClick={this.getCreateSavingPot}
            type="button"
            className="col-xs-12 noPotMessage"
          >
            {content.SavingLinkPot}
          </button>
        );
        potHeaderContent = (
          <div>
            <div className="unallocated__message">
              {content.savingpotMainPageTitle1}{' '}
              <strong>{unallocatedAmount}</strong>{' '}
              {content.savingpotMainPageTitle2}
            </div>
            <div className="create_savingspot">
              <button
                type="button"
                className="page-options opt-green btn btn-link"
                onClick={this.getCreateSavingPot}
              >
                <span className="icon icon-add" />
                {content.SavingLinkPot}
              </button>
            </div>
          </div>
        );
      }
    }
    return (
      <div className="saving_pot_list__wrapper">
        {potHeaderContent}
        <div className="saving_pot_list">{potContent}</div>
      </div>
    );
  }
}

SavingPots.propTypes = {
  pots: PropTypes.array,
  unallocatedAmount: PropTypes.number,
  content: PropTypes.object,
};

export { SavingPots };
